import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Pricing as PricingComponent } from "@/components/Pricing";
import { SEO, buildBreadcrumbSchema } from "@/components/seo/SEO";

const Pricing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Pricing Plans — Email2Contact for Outlook"
        description="Compare Email2Contact pricing plans: Starter, Pro and Enterprise. Transparent EUR pricing, GDPR-compliant, EU-hosted AI, cancel anytime."
        path="/pricing"
        jsonLd={buildBreadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Pricing", path: "/pricing" },
        ])}
      />
      <Navbar />
      <main className="flex-grow">
        <PricingComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
